<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <button
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div class="ac-header">
        Reactivate {{ selectedTech.firstName }} {{ selectedTech.lastName }}
      </div>
    </div>
    <div class="ac-footer-container">
      <button
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="ac-form-button"
        @click="reactivate"
      >
        Confirm
      </button>
    </div>
    <ProcessOverlay :show="processing" />
  </div>
</template>

<script>
import technicianMixin from '@shared/mixins/technicianMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'ReactivateTechnician',
  components: {
    ProcessOverlay,
  },
  mixins: [technicianMixin],
  data() {
    return {
      processing: false,
    };
  },
  methods: {
    async reactivate() {
      this.processing = true;
      const {
        id,
      } = this.selectedTech;
      await this.$store.dispatch('reactivateTech');
      await this.$store.dispatch('getTechnicianById', { technicianId: id });
      this.toggleActionModal(false);
      this.processing = false;
    },
  },
};
</script>
